import React, { useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { ButtonIcon, CommentCard, FormHeader, SectionHeader, Tag } from "..";
import { getLanguage } from "../../utils/environment";
import moment from "moment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const lan = getLanguage();

const Index = ({ isUpdate, item, refresh }) => {
  let inputElement = null;

  const [collapse, setCollapse] = useState(false);

  inputElement = (
    <>
      <div className={`admin-news-comment-card-wrapper `}>
        <div className="anccw__img">
          <img src={item?.images?.[0]?.url} alt={"news-img"} />
        </div>
        <div className={"anccw__body "}>
          <div className={"anccwb__content"}>
            <div>
              <FormHeader
                data={{
                  formHeader: isUpdate
                    ? "(Update) " + item?.title?.[lan]
                    : item?.title?.[lan],
                  size: "xs",
                }}
              />
            </div>
            <div className={"anccwb__c-date"}>
              {item?.created_at
                ? moment(item?.created_at).format("MMMM Do YYYY, h:mm:ss a")
                : moment().format("DD MMMM YYYY")}
            </div>
            {collapse ? (
              <>
                {item?.comments?.length > 0 ? (
                  <div className="anccwb__comment_list">
                    {item?.comments?.map((comment, index) => (
                      <CommentCard
                        key={index}
                        comment={comment}
                        index={index}
                        newsId={item?.news_id}
                        type={"admin"}
                        refresh={refresh}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="nwsng__comment_no_comments">
                    No comments yet. Be the first to comment!
                  </div>
                )}
              </>
            ) : (
              <div className="nwsng__comment_no_comments">
                Comments ({item?.comments?.length || 0})
              </div>
            )}
          </div>
          <div className={"anccwb__action"}>
            <ButtonIcon
              data={{ iconName: "chevronDown", size: "sm" }}
              onClick={() => setCollapse(!collapse)}
            />
          </div>
        </div>
      </div>
    </>
  );
  return <>{inputElement}</>;
};

export default withRouter(Index);
